import type { ReactNode } from 'react';

export const symbol_forward_5: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M339.5-108Q274-136 225-185t-77-114.5Q120-365 120-440t28-140.5Q176-646 225-695t114.5-77Q405-800 480-800h23l-57-57q-8-8-8-20.5t8-20.5q8-8 20-8.5t20 7.5l106 106q9 9 9 21t-9 21L487-646q-9 9-21 9t-21-9q-9-9-9-21t9-21l52-52h-22q-125 0-210 87.5T180-440q0 125 87.5 212.5T480-140q125 0 212.5-87.5T780-440q0-13 8.5-21.5T810-470q13 0 21.5 8.5T840-440q0 75-28 140.5T735-185q-49 49-114.5 77T480-80q-75 0-140.5-28ZM522-310H405q-11 0-18-7t-7-18q0-11 7-18t18-7h102v-56H405q-11 0-18-7t-7-18v-106q0-11 7-17.5t18-6.5h127q10 0 17 6.5t7 17.5q0 11-6.5 18t-17.5 7H430v57h102q11 0 17.5 6.5T556-441v97q0 14-10 24t-24 10Z"
		/>
	</svg>
);
